import { useQuery } from "@tanstack/react-query";
import { API_PAYMENT } from "../apis";
import { QUERY_KEY } from "../keys";

export const useGetPaymentList = <T>(params?: { [key: string]: any }) => {
    const { data, isLoading } = useQuery({
        queryKey: [QUERY_KEY.GET_PAYMENT_ROOM_LIST, params],
        queryFn: () => API_PAYMENT.getPaymentList<T>({ ...params }),
    });

    return { data, isLoading };
};
